import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevenueInlineIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 67,
	height: 39,
	viewBox: "0 0 67 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.6817 36.5584L27.0917 13.4584L30.7417 31.4484L60.3617 5.12839",
		stroke: "white",
		strokeWidth: 5,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M59.6617 20.0884L63.1218 3.0784L46.9818 2.49839",
		stroke: "white",
		strokeWidth: 5,
		strokeMiterlimit: 10
	})]
});
export default SvgRevenueInlineIcon;
